import { EasyBorrowContainer } from '@/features/sparklend/easy-borrow/EasyBorrowContainer'

export function EasyBorrowPage() {
  return <EasyBorrowContainer />
}
